export const DATA_SHARED_SERVICE_KEYS = {
  CHECKOUT_DELIVERY_DETAILS: 'CHECKOUT_DELIVERY_DETAILS',
};
